import { render, staticRenderFns } from "./SetsReceiveNumber.vue?vue&type=template&id=6dd4849a&scoped=true&"
import script from "./SetsReceiveNumber.vue?vue&type=script&lang=js&"
export * from "./SetsReceiveNumber.vue?vue&type=script&lang=js&"
import style0 from "./SetsReceiveNumber.vue?vue&type=style&index=0&id=6dd4849a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd4849a",
  null
  
)

export default component.exports